import { doc, getDoc, getDocFromServer } from "firebase/firestore";
import { db } from "../firebase";
import { GetServiceOpts, EntityGet, EntityServerGet } from "../types";
import { Sms } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type SmsGetService<T> = (
  id: string,
  opts?: GetServiceOpts
) => Promise<T | null>;

const get: SmsGetService<EntityGet<Sms>> = async (id, opts = {}) => {
  const docRef = doc(db, `/sms/${id}`);
  const { disableCache } = opts;
  const getFn = disableCache ? getDocFromServer : getDoc;
  const docSnap = await getFn(docRef);
  if (docSnap.exists()) {
    return processTimestampFields(
      transformMetadata({
        ...docSnap.data(),
        id: docSnap.id,
      } as EntityServerGet<Sms>)
    ) as EntityGet<Sms>;
  }
  return null;
};

export default get;
